import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconSettings, IconClose, IconDelete, IconWrapperRounded, IconKiosk, IconPickup, IconDelivery, IconDineIn, IconArrowForward, IconCloudWrapper, IconCloud, IconCheck } from "./icons";
import { ColorPicker, Switch } from "@lib/components";
import { HeaderTitleWrapper, MenuItem, QuickSettingsContainer, QuickSettingsHeaderWrapper, QuickSettingsBodyWrapper, QuickSettingsFooterWrapper, QuickSettingsButton, QuickSettingsItemsContainer, QuickSettingsItemsWrapper, QuickSettingsItemWrapper, ButtonV2, MenuColorHeaderWrapper, MenuColorHeaderTitleWrapper, MenuColorDescription, MenuColorBodyWrapper, MenuColorFormGroup, MenuColorLabel, MenuColorColorPickerWrapper, MenuColorColorPickerText, MenuColorPresetsList, MenuColorPresetsListItem, MenuColorPresetsListItemContent, MenuColorFooterWrapper, MenuToggleContainer, MenuToggleText, MenuServiceTypeContainer, MenuServiceTypeItem, MenuLineSeparator, MenuPublishPlatformContainer, MenuPublishPlatFormItem, MenuPublishPlatFormItemHeader, MenuPublishPlatFormItemHeaderLabel, MenuStatusAlert, MenuStatusAlertText, MenuStatusLabelAvailable, MenuStatusServiceList, MenuStatusServiceListItem, MenuStatusServiceListRow, MenuStatusShowSettingsContainer, MenuStatusShowSettingsText, MenuActionContainer, MenuActionItem } from "./layout.c";
import { CoreUtils } from '@lib/common';
import { MoreActionSideBar } from './more-action-menu';
import { IconKioskWrapper } from '../../ui/restaurant/views/menus-v2/item-v2';


interface Props extends WithTranslation {
    show?: boolean;
    onHide?: () => void;
    onSave: (color: string) => void;
    onShowSettings?: () => void;
    title?: string;
    value?: string;
    filterPos?: boolean;
    filterOnline?: boolean;
    onTogglePos?: () => void;
    onToggleOnline?: () => void;
}
interface State {
    color: string;
}

@inject("store") @observer
class MenuFilterMenuClass extends MobxComponent<Props, State> {
    constructor(props: Props) {
		super(props);
		this.state = {
            color: props.value || '#000000'
        };
	}

    render() {
        const { store, t} = this.injected;
        const { show, onHide, onSave, title, onShowSettings, filterPos, filterOnline, onTogglePos, onToggleOnline } = this.props;
        const { color } = this.state;
        const rawName = store.restaurant?.name;
        const fromRestaurant =
            rawName == null || (typeof rawName === 'string' && rawName.trim() === '')
                ? ''
                : typeof rawName === 'object'
                    ? JSON.stringify(rawName)
                    : String(rawName);
        const resolvedTitle =
            title != null && String(title).trim() !== ''
                ? String(title)
                : fromRestaurant || 'Acme Pizza';
        return (
        <QuickSettingsContainer className={show ? 'active': ''}>
            <MenuColorHeaderWrapper>
                <MenuColorHeaderTitleWrapper>
                    {resolvedTitle}
                </MenuColorHeaderTitleWrapper>
                <MenuItem onClick={onHide}><IconClose /></MenuItem>
            </MenuColorHeaderWrapper>
            <MenuColorBodyWrapper style={{minHeight: '50vh', overflowY:'scroll'}}>
                <MenuColorLabel>Select items to be shown</MenuColorLabel>
                <MenuActionContainer>
                    <MenuActionItem
                        className={'menu-filter' + (filterPos ? ' active' : '')}
                        onClick={() => onTogglePos?.()}
                    >
                        <span className='span-option'>
                        <IconKioskWrapper>
                            <IconKiosk />
                        </IconKioskWrapper>
                        POS
                        </span>
                        <span className='span-check'>
                        <IconCheck />
                        </span>
                    </MenuActionItem>
                    <MenuActionItem
                        className={'menu-filter' + (filterOnline ? ' active' : '')}
                        onClick={() => onToggleOnline?.()}
                    >
                        <span className='span-option'>
                        <IconCloudWrapper>
                            <IconCloud />
                        </IconCloudWrapper>
                        Online
                        </span>
                        <span className='span-check'>
                        <IconCheck />
                        </span>
                    </MenuActionItem>
                </MenuActionContainer>
            </MenuColorBodyWrapper>
            <MenuColorFooterWrapper>
                
            </MenuColorFooterWrapper>
        </QuickSettingsContainer>
        )
    }
}
export const MenuFilterMenu = withTranslation()(MenuFilterMenuClass);
